import request from '@/utils/request'
import qs from 'qs'

export function getWalkinGuestReportApi(query) {
  return request({
    url: '/report-service/v1/walkins-guest-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getWalkinGuestReportApiExcel(query) {
  return request({
    url: '/report-service/v1/walkins-guest-report/list-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}

export function getBookingGroupReportApi(query) {
  return request({
    url: '/report-service/v1/report/booking-group',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getBookingGroupReportExcel(query) {
  return request({
    url: '/report-service/v1/report/booking-group/excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}

export function getInHouseGuestReportApi() {
  return request({
    url: '/report-service/v1/daily-report/in-house-room',
    method: 'get'
  })
}
export function getInHouseGuestReportExcel() {
  return request({
    url: '/report-service/v1/daily-report/in-house-room/excel',
    method: 'get',
    responseType: 'blob'
  })
}
export function getPaymentReportApi(query) {
  return request({
    url: '/report-service/v1/payment-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getPaymentReportApiExcel(query) {
  return request({
    url: '/report-service/v1/payment-report/list-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
export function getRecodeApi() {
  return request({
    url: '/report-service/v1/payment-report/list-recode',
    method: 'get'
  })
}
export function getInvoiceApi() {
  return request({
    url: '/report-service/v1/payment-report/list-invoice-code',
    method: 'get'
  })
}

export function getRoomStatusDiaryReportApi(query) {
  return request({
    url: '/report-service/v1/room-status-history-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getRoomStatusDiaryReportApiExcel(query) {
  return request({
    url: '/report-service/v1/room-status-history-report/list-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}

export function getOooAndOosReportApi(query) {
  return request({
    url: '/report-service/v1/ooo-oos-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getOooAndOosReportApiExcel(query) {
  return request({
    url: '/report-service/v1/ooo-oos-report/list-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}

export function getDepartGuestReportApi(query) {
  return request({
    url: '/report-service/v1/revenue-report/depart-guest',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getDepartGuestReportExcel(query) {
  return request({
    url: '/report-service/v1/revenue-report/depart-guest-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
export function getHouseKeepingMustCheckReportApi(query) {
  return request({
    url: '/report-service/v1/room-need-check-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getHouseKeepingMustCheckReportApiExcel(query) {
  return request({
    url: '/report-service/v1/room-need-check-report/list-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}

export function getRoomPlan(query) {
  return request({
    url: '/report-service/v1/statistic/room-plan',
    method: 'get',
    params: query
  })
}

export function getDailyTransactionSummaryReport(query) {
  return request({
    url: '/report-service/v1/invoice-report/daily-transaction-summary',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getDailyTransactionSummaryReportExcel(query) {
  return request({
    url: '/report-service/v1/invoice-report/daily-transaction-summary/excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}

export function getIncurredTransReportApi(query) {
  return request({
    url: '/report-service/v1/report/room-transaction',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getIncurredTransReportApiExcel(query) {
  return request({
    url: '/report-service/v1/report/room-transaction/to-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}

/**
 *
 * @param {Object} query
 * @param {string} [query.recode]
 * @param {string} query.dateFrom
 * @param {string} query.dateTo
 * @param {Number} query.agentId
 * @returns
 */
export function getAgencyDetailReportApi(query) {
  return request({
    url: '/report-service/v1/invoice-report/agent/detail',
    method: 'get',
    params: query
  })
}

/**
 *
 * @param {Object} query
 * @param {string} [query.recode]
 * @param {string} query.dateFrom
 * @param {string} query.dateTo
 * @param {Number} query.agentId
 * @returns
 */
export function getAgencyDetailReportExcelApi(query) {
  return request({
    url: '/report-service/v1/invoice-report/agent/detail/excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}
